{
    "name": "idle",
    "duration": 1.33333337,
    "keyframes": {
        "/m_LocalRotation.x": [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
        "/m_LocalRotation.y": [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
        "/m_LocalRotation.z": [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
        "/m_LocalRotation.w": [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0],
        "/m_LocalPosition.x": [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
        "/m_LocalPosition.y": [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
        "/m_LocalPosition.z": [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
        "/m_LocalScale.x": [
            1.0, 1.00468671, 1.013196, 1.02046323, 1.02142358, 1.01260757, 1.00295269
        ],
        "/m_LocalScale.y": [
            1.0, 0.995589137, 0.9813216, 0.9669979, 0.962419033, 0.974985242, 0.99224174
        ],
        "/m_LocalScale.z": [
            1.0, 1.00468671, 1.013196, 1.02046323, 1.02142358, 1.01260757, 1.00295269
        ]
    },
    "wrapMode": 2,
    "guid": "bc44a34b00e954b96a87c13af1a539d0",
    "assetPath": "Assets/Characters/Prototype/blob@idle.fbx"
}
